import {MediaCardType} from '@wandb/weave/common/types/media';

import * as PanelTypes from '../../../../state/views/panel/types';
import * as PanelBankSectionConfigTypes from '../../../../state/views/panelBankSectionConfig/types';
import {ClassLabelMap} from '../../../../util/media';
import {RampKey} from '../../../../util/useRampFlag';
import {MediaBrowserPanelConfig} from '../../../PanelMediaBrowser/common';
import {MediaConfigWithDefaults} from '../../../PanelMediaBrowser/Component';

export enum SettingsLevel {
  PANEL = 'panel',
  SECTION = 'section',
  WORKSPACE = 'workspace',
}

type MediaSetting = {
  component: React.FC<{}>;
  mediaTypes: MediaCardType[]; // The media types that this setting is relevant for
  shouldShow?: (
    config: MediaConfigWithDefaults,
    hasMasks: boolean,
    hasBoundingBoxes: boolean,
    passingRampFlags?: Partial<Record<RampKey, boolean>>
  ) => boolean;
  // If the component has local state that is affected by some other setting,
  // this can be used to keep them in sync to remount the component and re-initialize the state.
  getComponentKey?: (config: MediaConfigWithDefaults) => string;
  settingsLevels: SettingsLevel[];
  configKey: keyof MediaBrowserPanelConfig;
};

export type MediaSettingsSection = {
  title: string;
  settings: MediaSetting[];
};

export type MediaSettingsTab = {
  title: string;
  sections: MediaSettingsSection[];
};

export type MediaSettingsDrawerPanelProps = {
  panelRef: PanelTypes.Ref;
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref;
};

export type ContextProviderState = {
  config: MediaConfigWithDefaults;
  configWithoutDefaults: MediaBrowserPanelConfig;
  hasMasks: boolean;
  hasBoundingBoxes: boolean;
  loading: boolean;
  mediaCardTypes: MediaCardType[] | undefined;
  rampFlags: Partial<Record<RampKey, boolean>> | undefined;
  updateConfig: (config: Partial<MediaConfigWithDefaults>) => void;
  unsetConfigField: (field: keyof MediaConfigWithDefaults) => void;
  allBoxes: ClassLabelMap;
  sliderRanges: Record<
    string,
    {
      min: number;
      max: number;
    }
  > | null;
  allMasks: ClassLabelMap;

  numberOfOverridesBelow?: Partial<
    Record<
      SettingsLevel,
      Partial<Record<keyof MediaBrowserPanelConfig, number>>
    >
  >;
  clearOverridesBelow?: Partial<
    Record<SettingsLevel, (key: keyof MediaBrowserPanelConfig) => void>
  >;
  settingsLevel: SettingsLevel;
};
